import { Category } from '@wix/answers-api';

import {
  EXCLUDED_CATEGORIES,
  TWINS_CATEGORY_ID,
  WIXEL_CATEGORY_ID,
} from '../constants';
import { findCategoryInTreeById, getCategoriesPaths } from './categories';
import { PageType } from '../types';

export const isExcludedCategoryInPath = (
  pageType: PageType,
  categories: Category[],
  itemId?: string,
  articleCategoryId?: string,
  excludedCategories: string[] = EXCLUDED_CATEGORIES
): boolean => {
  if (pageType === PageType.Category) {
    const categoriesPath = itemId
      ? getCategoriesPaths(categories, [itemId])[itemId].filter(
          (pathItem) => !!pathItem
        )
      : false;

    const isExcludedCategoryPage =
      itemId && excludedCategories.includes(itemId);
    const isExcludedSubCategoryPage =
      categoriesPath && itemId
        ? excludedCategories.some(
            (excludedId) => !!findCategoryInTreeById(categoriesPath, excludedId)
          )
        : false;

    return isExcludedCategoryPage || isExcludedSubCategoryPage;
  }
  if (pageType === PageType.Article) {
    const categoriesPath = articleCategoryId
      ? getCategoriesPaths(categories, [articleCategoryId])[
          articleCategoryId
        ].filter((pathItem) => !!pathItem)
      : false;
    const isExcludedSubCategoryPage =
      categoriesPath && articleCategoryId
        ? excludedCategories.some(
            (excludedId) => !!findCategoryInTreeById(categoriesPath, excludedId)
          )
        : false;
    return isExcludedSubCategoryPage;
  }
  return false;
};

export const isExcludedCategory = (categoryId: string): boolean =>
  EXCLUDED_CATEGORIES.includes(categoryId);

export const filterExcludedCategories = (categories: Category[]) =>
  categories.filter((category) => !isExcludedCategory(category.id));

export const isWixelRelated = (
  pageType: PageType,
  categories: Category[],
  itemId?: string,
  articleCategoryId?: string
): boolean =>
  isExcludedCategoryInPath(pageType, categories, itemId, articleCategoryId, [
    WIXEL_CATEGORY_ID,
  ]);

export const isTwinsRelated = (
  pageType: PageType,
  categories: Category[],
  itemId?: string,
  articleCategoryId?: string
): boolean =>
  isExcludedCategoryInPath(pageType, categories, itemId, articleCategoryId, [
    TWINS_CATEGORY_ID,
  ]);
